import React, { useState } from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const metricOptions = [
  { label: 'Units Sold', id: 'unitsSold', metricType: 'UnitsSold' },
  { label: '1P Units Sold', id: 'onePUnitsSold', metricType: 'firstPartyUnitsSold' },
  { label: '3P Units Sold', id: 'threePUnitsSold', metricType: 'ThirdPartyUnitsSold' }
];

const AtlasUnitsSold1p3pSplineChart = () => {
  const [selectedMetric, setSelectedMetric] = useState(metricOptions[0]);
  const { isProductEntity } = useProductEntity();

  if (isProductEntity) {
    return (
      <AtlasV2DorisSplineChart
        queryKey="UnitsSoldSplineChart"
        title="Units Sold"
        methodName="sales/GetSalesMetrics"
        metricTypeDisplay={METRICTYPE.VOLUME}
        metricType="UnitsSold"
      />
    );
  }

  return (
    <AtlasV2DorisSplineChart
      queryKey="UnitsSoldSplineChart"
      title={selectedMetric.label}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType={selectedMetric.metricType}
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          singleDropdownProps: {
            onChange: (s) => setSelectedMetric(metricOptions.find((option) => option.id === s.id)),
            defaultLabel: selectedMetric.label,
            selectedId: selectedMetric.id,
            buttonVariant: 'title',
            options: metricOptions,
            shouldShowFullItemText: true
          }
        };
      }}
    />
  );
};
export default AtlasUnitsSold1p3pSplineChart;
